import handleNextPage from './handleNextPage';

/**
 * Returns a callback to handle news filter selection.
 * @return {Function} A callback function
 */
const handleFilter = (component, $newsItems, ...args) => (e) => {
    // Filter items that do not match the selection
    $newsItems.hide().removeAttr('data-filtered');
    if ($(e.target).is(':checked')) {
        $newsItems
            .filter(`:not([data-filter-attribute="${e.target.value}"])`)
            .attr('data-filtered', '');
    }
    // Show items
    handleNextPage(component, $newsItems, ...args)();
};

export default handleFilter;



// WEBPACK FOOTER //
// ./src/scripts/components/news-list/handleFilter.js